import { z } from "zod";
import { PlanKey, Suspension } from "./enums";

/** What the console answers for a tenant (03-api-openapi.yaml#/components/schemas/Entitlements; BR-248, BR-249). */
export const EntitlementsSchema = z.object({
  organizationId: z.string().uuid(),
  planKey: PlanKey.schema.nullable(),
  /** effective Teams limit: override, else tier; -1 = unlimited */
  teamsLimit: z.number().int(),
  priceCents: z.number().int().nullable(),
  flags: z.record(z.boolean()),
  /** `beta_opt_in` flags the tenant Admins may switch on (BR-250); `flags` already reflects the opt-ins sent with the request */
  betaOptIn: z.array(z.object({ key: z.string(), description: z.string() })).default([]),
  suspension: Suspension.schema,
  internal: z.boolean(),
});
export type Entitlements = z.infer<typeof EntitlementsSchema>;
